import { isNonEmptyArray } from '../../utils/array-utils';
import { assertIsError } from '../../utils/assert-is-error';
import { getCxmExperience } from './get-cxm-experience';
import { toV2EntityType } from './utils/entity-type-converter';
import { cxmLoggerInstance } from './utils/logger';
/**
 * If CXM integration is enabled, will get the ordered list of film IDs, otherwise returns
 * an empty list.
 *
 * @param requestContext the request context for this particular film list
 */
export const getCxmEntities = async (requestContext) => {
    if (!requestContext.isCxmIntegrationEnabled)
        return [];
    try {
        const response = await getCxmExperience(requestContext);
        const experienceOutcomes = response.experiences.filter(experience => experience.entityType === toV2EntityType(requestContext.entityType) &&
            experience.componentId === requestContext.componentId);
        return isNonEmptyArray(experienceOutcomes)
            ? experienceOutcomes[0].promoteEntity.entityListToPromote.entities
            : [];
    }
    catch (error) {
        assertIsError(error);
        // TODO: Dispatch experience load failure to CXM Tracking API. #286494
        cxmLoggerInstance.error(error.message);
        throw error;
    }
};
